import { render, staticRenderFns } from "./employee-detail.vue?vue&type=template&id=f2982392&"
import script from "./employee-detail.vue.ts?vue&type=script&lang=ts&"
export * from "./employee-detail.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports